import { MemberCardDisplayMode } from './MemberCardDisplayMode'

import LambdaUtils from './LambdaUtils'
import {PhoneNumberUtils} from '@fibo-app/fibo-collab-shared'

class InMemoryMemberEditor {

  constructor(teamInfo, teamMembers, currentUser, defaultNewMember) {
    this.member = defaultNewMember
    this.teamInfo = teamInfo
    this.teamMembers = teamMembers
    this.currentUser = currentUser
  }

  getMember() {
    return this.member
  }

  getDisplayMode() {
    return MemberCardDisplayMode.Create
  }

  allowPhoneNumberEdits() {
    return true
  }

  showSettings() {
    return false
  }

  disableEdits() {
    return false
  }

  disableAdminSwitch() {
    return true
  }

  updateMemberField(name, value) {
    this.member[name] = value
  }

  completeAction() {
    // Call lambda function to create the team invite
    const helper = new LambdaUtils()
    helper.sendTeamInvitation(this.currentUser, this.member, this.teamInfo)
  }

  teamMemberExist(number){
    return this.teamMembers && this.teamMembers.find(m => m.userId === number)
  }

  validate() {
    const validation = PhoneNumberUtils.validateIntlNumber(this.member.countryCode, this.member.number)
    if (!this.member.displayName) {
      return { error: 'Display name is required.' }
    } else if (validation.errMessage) {
      return { error: validation.errMessage }
    } else if (!validation.completeNumber){
      return { error: 'Cannot verify number.' }
    } else if (this.teamMemberExist(validation.completeNumber)){
      return { error: 'User is already part of the team'}
    }
    this.member.userId = validation.completeNumber
    return { success: true }
  }

  /**
   * Cancel action on create mode does nothing
   */
  cancelAction() { }

  showActionCompleteButton() {
    return true
  }

  showActionCancelButton() {
    return true
  }

}

export default InMemoryMemberEditor



// WEBPACK FOOTER //
// ./src/infra/InMemoryMemberEditor.js